import Toggle from '../../utils/Toggle';
import React, { useEffect, useState } from 'react';
import { find, propEq } from 'rambda';
import axios from 'axios';
import { toast } from 'react-toastify';

const clientDetailsUrl = id => `/client/v1/clientDetails/${id}`;

const ClientModule = ({ module, modules, clientId }) => {
	const [enabled, setEnabled] = useState();

	useEffect(() => {
		const theModule = find(propEq('title', module.name), modules);
		if (theModule) {
			module.enabled = theModule.enabled;
			module.id = theModule.id;
			setEnabled(module.enabled);
		}
	}, [module, modules]);

	function handleSwitch() {
		const data = {
			modules: [
				{
					feature: module.feature,
					enabled: !enabled ? 1 : 0,
				},
			],
		};
		axios({
			method: 'PATCH',
			url: clientDetailsUrl(clientId),
			data: data,
		}).then(
			response => {
				toast('Modules updated', {
					autoClose: 6000,
					type: toast.TYPE.SUCCESS,
				});
				setEnabled(!enabled);
			},
			error => {
				console.log(error);
				toast('Modules not updated', {
					autoClose: 6000,
					type: toast.TYPE.ERROR,
				});
			},
		);

		setEnabled(!enabled);
	}

	return (
		<li key={module.id} className="px-6 py-4">
			<div>
				{module.name}&nbsp;-&nbsp;
				<span className="text-sm text-gray-500">{module.description}</span>
			</div>
			<div>
				<Toggle label="" value={enabled} onChangeValue={handleSwitch} />
			</div>
		</li>
	);
};

export default ClientModule;
